module.exports = __webpack_public_path__ + "img/92.2bd80902.jpg";